import thunk    from 'redux-thunk';
import reducers from './reducers';
import { createStore, applyMiddleware } from 'redux';

const middleWare = [thunk];

const createStoreWithMiddleware = applyMiddleware(...middleWare)(createStore);

const store = createStoreWithMiddleware(reducers);

export default store;

